import React from 'react';

import { StyledInput } from './styles';

const TextInput = ({ ...props }) => (

  <StyledInput {...props} />

);

export default TextInput;
